/**
 * Producto inactivo (estado 0): visible en búsqueda pero no seleccionable en pedidos/cotizaciones.
 */
export function isProductInactiveInSearch(product: { estado?: number | null }): boolean {
  const e = product.estado
  if (e === undefined || e === null) return false
  return Number(e) === 0
}
